var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconWhiteRightArrow = function SvgIconWhiteRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 27,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M5.173 12.736h15.842c.598 0 1.073.475 1.073 1.073 0 .599-.475 1.074-1.073 1.074H5.173A1.067 1.067 0 0 1 4.1 13.809c0-.598.475-1.073 1.073-1.073"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M22.824 12.767c.291 0 .567.107.782.337a1.07 1.07 0 0 1-.046 1.518l-5.812 5.49a1.084 1.084 0 0 1-1.518-.046 1.07 1.07 0 0 1 .046-1.518l5.812-5.49c.214-.2.475-.291.736-.291"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M17.012 7.215c.26 0 .537.092.736.292l5.812 5.566a1.07 1.07 0 0 1 .03 1.518 1.07 1.07 0 0 1-1.517.031L16.26 9.056a1.07 1.07 0 0 1-.031-1.519c.215-.214.49-.337.782-.337z"
  })));
};
export default SvgIconWhiteRightArrow;